import React, {useState} from 'react'
import {Button, InputAdornment, TextField} from '@mui/material';
import Busy from '../../components/Busy';
import Error from '../../components/Error';
import Success from '../../components/Success';
import request from '../../util/SuperagentUtils';
import {getErrorMessageForNonStandardAndStandardResponse} from "../../util/NetworkErrorUtil";

export interface ForgotFormState {
  resetSuccessful: boolean;
  errorMessage: string;
}

interface ForgotFormProps {
  state: ForgotFormState;
  setState: React.Dispatch<React.SetStateAction<ForgotFormState>>;
}

const ForgotForm = ({ state, setState }: ForgotFormProps) => {

  const [email, setEmail] = useState<string>("");

  const handleForgotPassword = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    Busy.set(true);

    try {
      await request.post(`api/reset-password`).send({
        username: email.toLowerCase()
      }).set('accept', 'json');
      setEmail("")
      setState({
        resetSuccessful: true,
        errorMessage: ''
      });
    } catch (error: unknown) {
      const errorMessage = getErrorMessageForNonStandardAndStandardResponse(error, "Password reset failed");
      setState({
        resetSuccessful: false,
        errorMessage: errorMessage
      });
    } finally {
      Busy.set(false);
    }
  }

  return (
    <form onSubmit={handleForgotPassword} className='ss-forgot-password-form'>
      {!state.resetSuccessful ?
        <TextField
          id='forgot-password-email'
          type='email'
          InputLabelProps={{
            shrink: true,
          }}
          value={email}
          autoFocus={true}
          onChange={(e) => setEmail(e.target.value)}
          placeholder='Please enter your mail'
          className='ss-forgot-password-input'
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img src="https://static.secur.space/icons/Email.png" alt=""
                     className='ss-forgot-password-icon-email'/>
              </InputAdornment>
            ),
          }}
          inputProps={{
            'aria-describedby': 'forgot-password-instructions'
          }}
          fullWidth
          variant="standard"
          label="Email"
        /> : ''
      }
      {
        state.errorMessage ?
          <Error>{state.errorMessage}</Error>
          :
          ''
      }
      {
        state.resetSuccessful ?
          <Success>If you have an account, you'll receive an email with a link to reset your password.</Success>
          :
          ''
      }
      <div className="clear"></div>
      <Button disabled={!email} fullWidth type='submit' variant="contained" color="primary">
        SUBMIT
      </Button>
    </form>
  )
}

export default ForgotForm
